/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum Urgency {
  Immediate = "Immediate",
  Exploring = "Exploring",
  Months = "Months",
}

export const UrgencyDisplay: Record<Urgency, string> = {
  [Urgency.Immediate]: "Immediate",
  [Urgency.Exploring]: "Exploring",
  [Urgency.Months]: "Months",
};
